<template>
  <app-graph :traces="traces" :title="selectedTrialName" :graph-type="graphType" />
</template>

<script>
import _ from 'lodash'
import AppGraph from '@/components/common/AppGraph'
import { getXAxis, GraphTypes, TraceTypes } from '@/helpers/graph-helper'
import trialSummaryService from '@/services/trial-summary-service'
import { vuetifyColors } from '@/assets/vuetify-config'
import { summaryValues } from '@/helpers/summary-value-helper'

export default {
  components: {
    AppGraph
  },
  props: {
    editedSite: { type: Object, default: null },
    orgTrialExternalId: { type: String, default: null },
    trialId: { type: String, default: null },
    trialExternalId: { type: String, default: null },
    selectedTrialName: { type: String, default: null }
  },
  data() {
    return {
      loading: true,
      trends: []
    }
  },
  computed: {
    graphType() {
      return GraphTypes.STACKED_BAR
    },
    sortedTrends() {
      return _.sortBy(this.trends, 'trendDate')
    },
    x() {
      return getXAxis(this.sortedTrends)
    },
    actualTrace() {
      return this.getTraceFromTrends(
        this.sortedTrends,
        TraceTypes.ENROLLED,
        'Actual Enrollment',
        vuetifyColors.primary
      )
    },
    targetTrace() {
      return this.getTraceFromTrends(
        this.sortedTrends,
        TraceTypes.PLANNED_ENROLLMENT,
        'Expected Enrollment',
        vuetifyColors.error
      )
    },
    traces() {
      return [this.actualTrace, this.targetTrace]
    },
    trendRequestParams() {
      return {
        trialId: this.trialId,
        cumulative: true,
        summaryValues: [
          summaryValues.TREND_DATE,
          summaryValues.PATIENT_ENROLLED_COUNT,
          summaryValues.PLANNED_ENROLLMENT_TO_DATE,
          summaryValues.TRIAL_ID,
          summaryValues.TRIAL_FRIENDLY_NAME,
          summaryValues.ORGANIZATION_NAME,
          summaryValues.ORGANIZATION_EXTERNAL_ID
        ]
      }
    }
  },
  watch: {
    trendRequestParams() {
      this.fetchTrends()
    }
  },
  created() {
    this.fetchTrends()
  },
  methods: {
    async fetchTrends() {
      this.loading = true
      try {
        let { data } = await trialSummaryService.listTrialSummaryTrends(this.trendRequestParams)
        this.trends = data
      } finally {
        this.loading = false
      }
    },
    getTraceFromTrends(trends, status, name, color) {
      return {
        line: { color: color },
        mode: 'lines',
        x: this.x,
        y: _.map(trends, trend => trend[status]),
        name: name
      }
    }
  }
}
</script>
